import { defineModule } from '../types.js';
export default defineModule({
    id: 'previsionnel',
    nom: 'Prévisionnel',
    description: 'Construction budgétaire, trajectoires et simulateur, scénarios dérivés, synthèse.',
    famille: 'pilotage',
    dependances: [],
    activableParDefaut: true,
    desactivable: true,
    routesApi: ['/api/budget', '/api/budget-2027', '/api/scenarios', '/api/simulation', '/api/simulations'],
    droits: {
        'previsionnel.consulter': { description: 'Consulter le prévisionnel et les scénarios', niveau: 'lecture' },
        'previsionnel.administrer': { description: 'Créer et modifier les scénarios dérivés', niveau: 'administration' },
        // Accordé en outre nominativement par le serveur (`BUDGET_2027_COURRIELS`).
        'previsionnel.brouillon2027': { description: 'Préparer le budget 2027 et la proposition salariale', niveau: 'administration' },
    },
    navigation: [
        { cle: 'synthese', libelle: 'Synthèse', picto: '≡', groupe: 'Exercice en cours', ordre: 20, droit: 'previsionnel.consulter' },
        { cle: 'budget', libelle: 'Construction budgétaire', picto: '⊞', groupe: 'Prévisionnel', ordre: 30, droit: 'previsionnel.consulter' },
        { cle: 'budget-2027', libelle: 'Budget 2027 — brouillon', picto: '✎', groupe: 'Prévisionnel', ordre: 35, droit: 'previsionnel.brouillon2027' },
        { cle: 'trajectoires', libelle: 'Trajectoires et simulateur', picto: '↗', groupe: 'Prévisionnel', ordre: 50, droit: 'previsionnel.consulter' },
        { cle: 'scenarios', libelle: 'Scénarios', picto: '⊞', groupe: 'Administration', ordre: 90, droit: 'previsionnel.consulter' },
    ],
});
//# sourceMappingURL=previsionnel.js.map